<form class="d-flex d-inline-flex">
    <div class="form-group hidden">
      <div class="input-group">
        <input name="datepicker"
               class="form-control"
               ngbDatepicker
               #datepicker="ngbDatepicker"
               [autoClose]="'outside'"
               (dateSelect)="onDateSelection($event)"
               [displayMonths]="2"
               [dayTemplate]="t"
               outsideDays="hidden"
               [startDate]="fromDate!"
               tabindex="-1">
        <ng-template #t let-date let-focused="focused">
          <span class="custom-day"
                [class.focused]="focused"
                [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)"
                (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null">
            {{ date.day }}
          </span>
        </ng-template>
      </div>
    </div>
    <div class="form-group" style="width: 180px;">
      <div class="input-group">
        <input #dpFromDate
               class="form-control" placeholder="yyyy-mm-dd"
               name="dpFromDate"
               [value]="formatter.format(fromDate)"
               (input)="onFromInput(dpFromDate.value)">
          <button class="btn btn-outline-secondary calendar calendar-contrl" (click)="datepicker.toggle()" type="button"></button>
      </div>
    </div>
    <div class="form-group" style="width: 180px; margin-left: 30px;">
      <div class="input-group">
        <input #dpToDate
               class="form-control" placeholder="yyyy-mm-dd"
               name="dpToDate"
               [value]="formatter.format(toDate)"
               (input)="onToInput(dpToDate.value)">
          <button class="btn btn-outline-secondary calendar calendar-contrl" (click)="datepicker.toggle()" type="button"></button>
      </div>
    </div>
  </form>
